export const isGoodsOrGifts = slug => slug === 'goods' || slug === 'gifts'
export const flashIn = delay => `opacity 0ms ${delay}ms`
export const fadeIn = delay => `opacity 300ms ${delay}ms`
